import { MenuDefinition } from "@1js/acui-menu";

import { AppControlProps } from "../AppControlProps";

/**
 * Wraps an array of controls in a menu definition with a single menu section containing the controls.
 * @param controls - The list of controls to wrap in a menu
 */
export function getMenuDefinitionForControls(
  controls: AppControlProps[]
): MenuDefinition {
  return {
    sections: [
      {
        controls,
      },
    ],
  };
}
